/**
 * Public entry point for the tour system.
 *
 * Bootstrap once during app startup (see App.vue), passing app-specific glue:
 *
 *   import { initTours } from '@/tour';
 *   initTours({ isViewAs: () => someStore.isProxying });
 *
 * Then, from the screen that hosts a tour, auto-launch it:
 *
 *   import { useTour } from '@/tour';
 *   this.$nextTick(() => useTour().autoStart('announcements'));
 */

import { tourManager, type TourManagerInit } from './core/tourManager';
import { allTours } from './tours';

export { useTour } from './composables/useTour';
export { tourManager } from './core/tourManager';
export type { TourDefinition, TourStep, TourPlacement } from './core/types';

/**
 * Register every tour and wire the manager. Also processes `?tour=<id>` so QA and
 * design can force-launch any tour regardless of its config/seen state.
 */
export function initTours(options: TourManagerInit = {}): void {
  tourManager.init(options);
  tourManager.register(allTours);
  tourManager.handleQueryLaunch();
}
